/**
 * Frontend labels for acl-svc's service/module catalogue. Keep values exact: addService rejects
 * free-form labels, and invoice-svc checks the selected service against the resulting grant.
 */
export const VENDOR_SERVICE_OPTIONS = [
  { value: 'entity-setup', label: 'Entity setup' },
  { value: 'payroll', label: 'Payroll' },
  { value: 'compliance', label: 'Compliance' },
  { value: 'integrations', label: 'Integrations' },
] as const

export const DEFAULT_VENDOR_SERVICES = ['payroll']
